import { render, staticRenderFns } from "./ContentComponent.vue?vue&type=template&id=77b36319&"
import script from "./ContentComponent.vue?vue&type=script&lang=ts&"
export * from "./ContentComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports